import React from 'react';
import { CircularProgress } from '@mui/material';
import { observer } from 'mobx-react';
import {
  DiscountDto,
  PopulatedCampaignUserDtoStatusEnum,
} from '@coretava/api/ecommerce-service';
import { WheelDto } from '@coretava/api/events-service';
import WheelForm from './WheelForm';
import Congrats from './Congrats';

const WheelCampaign: React.FC<{
  status: PopulatedCampaignUserDtoStatusEnum,
  wheel: WheelDto,
  discount?: DiscountDto,
}> = ({
  status,
  wheel,
  discount,
}) => (
  React.useMemo(() => {
    switch (true) {
      case status === PopulatedCampaignUserDtoStatusEnum.Pending:
        return (
          <WheelForm wheel={wheel} />
        );
      case !discount:
        return <CircularProgress color="primary" />;
      case status === PopulatedCampaignUserDtoStatusEnum.Valid:
        return (
          <Congrats discount={discount} />
        );
      default:
        return null;
    }
  }, [
    status,
    discount,
    wheel,
  ])
);

export default observer(WheelCampaign);
